export default __webpack_public_path__ + "media/images/mailer/icon_email-d1750f0c54c92bf1235dc91dde6c0af2.png";